<template>
  <section id="login">
    <div style="margin-top:150px; margin-bottom:150px; ">
      <!-- Login Form -->

      <div class="container h-100 d-flex justify-content-center;">
        <div class="login my-auto" style="margin:auto; width:400px">
          <button type="button" aria-label="Close" class="close" @click="volver()">×</button>
          <form v-if="!procesando && !ingresarOTP && !passwordOK" style="padding:10px; margin:30px">
            <h3 style="text-align:center; padding-bottom:15px">Ingresá tu nueva contraseña</h3>

            <div class="form-group">
              <label>Contraseña</label>
              <input
                type="password"
                class="form-control"
                v-model="pass"
                placeholder="Ingresá tu contraseña"
              />
            </div>

            <div class="form-group">
              <label>Repetí Contraseña</label>
              <input
                type="password"
                class="form-control"
                v-model="passC"
                placeholder="Ingresá tu contraseña"
              />
            </div>

            <div v-if="mensaje" class="alert alert-danger" role="alert">{{mensaje}}</div>

            <div style="text-align:center">
              <button
                type="button"
                class="btn boton-primario"
                @click="actualizaPassword(codigo,pass,passC)"
              >Confirmar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "login",

  data() {
    return {
      pass: null,
      passC: null,
      correo: null,
      respuesta: "",
      mensaje: null,
      clave: null,
      procesando: false,
      ingresarOTP: false,
      passwordOK: false
    };
  },
  props: ["codigo"],

  computed: {
    ...mapGetters(["categorias", "userLogged", "pathAPI"])
  },

  methods: {
    actualizaPassword(codigo, password, passwordC) {
      this.mensaje = "";
      if (!password) {
        this.mensaje = "Debés ingresar una password";
        return;
      }
      if (!passwordC) {
        this.mensaje = "Debés confirmar la contraseña";
        return;
      }
      if (password != passwordC) {
        this.mensaje = "Las contraseñas deben ser iguales";
        return;
      }
      var self = this
      var bodyApi;
      bodyApi =
        "codigo_secreto=" +
        codigo +
        "&password=" +
        password +
        "&password_confirm=" +
        passwordC;
      fetch(self.pathAPI + "login.php?" + bodyApi, {
        method: "PUT",
        body: bodyApi,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var respuesta;
          respuesta = response.json();
          respuesta.then(function(result) {
            if (result.resultado === "ERROR") {
              self.mensaje = result.mensaje;
            } else {
              self.$router.push({ path: "/Login/Olvido" });
            }
          });
        } else {
          throw "Error en la llamada Ajax";
        }
      });
    },

    volver() {
      this.$router.push({ path: "/Login/inicio" });
    }
  },
  components: {},

  mounted: function() {}
};
</script>

<style scoped>
#login {
  background: url("/public/images/site/background-login.svg");
  background-repeat: repeat-x;
  display: table;
  background-size: 1000px;

  width: 100%;
  background-position-y: top;
}

.olvide-password {
  margin: 15px;
  padding: 5px 20px;
  border-radius: 20px !important;
  border: 0px !important;
  align-items: center;
  transition: 0.2s;
  cursor: pointer;
  font-size: 15px;
  font-family: "Patua One", cursive;
  color: rgb(93, 93, 93);
}
.olvide-password:hover {
  transition: 0.2s;
  z-index: 1;
  color: #9546af;
}

.login {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  background-color: #e9ecef;
  border-radius: 15px;
  -webkit-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
}

.close {
  padding: 0px;
  font-size: 40px;
  font-weight: 300;
}
.label {
  margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/startPage/NuevaPassword.vue